/* VINOD header behaviour: mega menu, mobile drawer, mobile search, live cart count */
(function () {
  'use strict';

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  function initMega(root) {
    var wrap = root.querySelector('[data-vd-navwrap]');
    if (!wrap) return;
    var mega = wrap.querySelector('[data-vd-mega]');
    if (!mega) return;
    var triggers = wrap.querySelectorAll('[data-vd-idx]');
    var bodies = mega.querySelectorAll('[data-vd-body]');
    var timer = null;

    function close() {
      mega.hidden = true;
      each(triggers, function (t) { t.classList.remove('is-active'); });
    }

    function open(idx) {
      var found = false;
      each(bodies, function (b) {
        var match = b.getAttribute('data-vd-body') === String(idx);
        b.hidden = !match;
        if (match) found = true;
      });
      if (!found) { close(); return; }
      each(triggers, function (t) { t.classList.toggle('is-active', t.getAttribute('data-vd-idx') === String(idx)); });
      mega.hidden = false;
    }

    each(triggers, function (t) {
      var idx = t.getAttribute('data-vd-idx');
      t.addEventListener('mouseenter', function () { clearTimeout(timer); open(idx); });
      t.addEventListener('focus', function () { clearTimeout(timer); open(idx); });
    });

    wrap.addEventListener('mouseleave', function () { timer = setTimeout(close, 120); });
    wrap.addEventListener('mouseenter', function () { clearTimeout(timer); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) close();
    });
  }

  function initDrawer(root) {
    var drawer = root.querySelector('[data-vd-drawer]');
    if (!drawer) return;
    var openers = root.querySelectorAll('[data-vd-drawer-open]');
    var closers = drawer.querySelectorAll('[data-vd-drawer-close]');

    function setOpen(on) {
      drawer.classList.toggle('is-open', on);
      document.documentElement.style.overflow = on ? 'hidden' : '';
      each(openers, function (o) { o.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    }

    each(openers, function (o) { o.addEventListener('click', function () { setOpen(true); }); });
    each(closers, function (c) { c.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) setOpen(false);
    });

    each(drawer.querySelectorAll('[data-vd-acc-head]'), function (head) {
      head.addEventListener('click', function () {
        var item = head.parentNode;
        var wasOpen = item.classList.contains('is-open');
        each(drawer.querySelectorAll('.vd-hdr__acc'), function (a) { a.classList.remove('is-open'); });
        each(drawer.querySelectorAll('[data-vd-acc-head]'), function (h) { h.setAttribute('aria-expanded', 'false'); });
        each(drawer.querySelectorAll('.vd-hdr__chev'), function (c) { c.innerHTML = '&#8250;'; });
        if (!wasOpen) {
          item.classList.add('is-open');
          head.setAttribute('aria-expanded', 'true');
          var chev = head.querySelector('.vd-hdr__chev');
          if (chev) chev.innerHTML = '&#9662;';
        }
      });
    });
  }

  function initMobileSearch(root) {
    var toggle = root.querySelector('[data-vd-msearch-toggle]');
    var box = root.querySelector('[data-vd-msearch]');
    if (!toggle || !box) return;
    toggle.addEventListener('click', function () {
      var on = !box.classList.contains('is-open');
      box.classList.toggle('is-open', on);
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) {
        var input = box.querySelector('input[name="q"]');
        if (input) input.focus();
      }
    });
  }

  function initCartCount(root) {
    var nodes = root.querySelectorAll('[data-vd-cart-count]');
    if (!nodes.length) return;
    function refresh() {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          each(nodes, function (n) {
            n.textContent = cart.item_count;
            n.hidden = cart.item_count === 0;
          });
        })
        .catch(function () {});
    }
    ['cart:updated', 'cart:build', 'cart:refresh', 'ajaxProduct:added'].forEach(function (evt) {
      document.addEventListener(evt, refresh);
    });
  }

  function init() {
    each(document.querySelectorAll('[data-vd-header]'), function (root) {
      if (root.getAttribute('data-vd-ready')) return;
      root.setAttribute('data-vd-ready', '1');
      initMega(root);
      initDrawer(root);
      initMobileSearch(root);
      initCartCount(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
